import { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import { getDB } from "../util/db";
import { emptyArray, setNavAdvisoryLockout, useIsVault } from "../util/utils";
import { Button } from "react-bootstrap";
import { useProfile } from "../components/ProfileContext";
import { User } from "../models/User";
import { ArrowDownUp, CheckLg, FilterCircle, FilterCircleFill, Lock, SortAlphaDown, SortAlphaDownAlt, SortDown, SortDownAlt, SortUp } from "react-bootstrap-icons";
import { SharingStatus } from "../components/SharingStatus";
// import { SampleJobs } from "./SampleJobs";
import PaginationSelector from "../components/PaginationSelector";
import { DateRangePicker } from "@cloudscape-design/components";



export function JobListingPage() {
	setNavAdvisoryLockout(false);

	let [jobs, setJobs] = useState(emptyArray);
	let [profile, setProfile] = useProfile();
	let isVault = useIsVault();

	// Return a <=> function with an option to reverse
	let sortFunction = function (a, b) {
		let result = 0;
		if (a[sortKey] < b[sortKey]) {
			result = -1;
		}
		if (b[sortKey] < a[sortKey]) {
			result = 1;
		}
		return search[sortKey]?.sortDir ? result : -result;
	}

	// Will be used to filter the jobs based on the search query
	let filterKey = function (item) {
		let result = true;
		for(const [key, val] of Object.entries(search)){

			if(item[key]){
				if(val.type === "string_submatch"){
					result = result && item[key].toLowerCase().includes(val.value.toLowerCase());
				} else if (val.type === "daterange"){
					const itemTime = new Date(item[key]);
					if(val.start){
						const start = new Date(val.start);
						start.setHours(0);
						result = result && start < itemTime;
					}
					if(val.end){
						const end = new Date(val.end);
						end.setUTCHours(23);
						end.setUTCMinutes(59);
						end.setUTCSeconds(59);

						result = result && itemTime < end;
					}
				}
			}

			if(!result){
				return result;
			}
		}
		return result;
	}

	// sortDir of 1 means you should reverse the sort
	const [search, setSearch] = useState({
		"name": {
			type: "string_submatch",
			value: "",
			label: "Job",
			sortDir: -1,
		},
		"companyName": {
			type: "string_submatch",
			value: "",
			label: "Company",
			sortDir: -1,
		},
		"location": {
			type: "string_submatch",
			value: "",
			label: "Location",
			sortDir: -1,
		},
		"updatedAt": {
			type: "daterange",
			start: "",
			end: "",
			label: "Last Change",
			sortDir: -1
		}
	});
	const [openSearch, setOpenSearch] = useState(true);
	const [paginationIndex, setPaginationIndex] = useState(0);
	const pageSize = 25;


	useEffect(() => {
		setPaginationIndex(0);
	}, [search])


	const [sortKey, setSortKey] = useState(null);
	const sortBtnMap = new Map();

	const sortAction = function (key) {
		return () => {
			if (sortKey === key) {
				setSearch({
					...search,
					[key]: {
						...search[key],
						sortDir: !search[key].sortDir
					}
				})
			} else {
				setSortKey(key);
			}
		}
	}

	

	// Set the sort buttons
	for (const [key, val] of Object.entries(search)) {
		if (sortKey === null) {
			sortBtnMap[key] = <Button className="sort-button" onClick={sortAction(key)}><ArrowDownUp></ArrowDownUp> </Button>;
		} else if (sortKey == key) {
			let sortBtn = null;
			if(val.type === "string_submatch"){
				sortBtn = val.sortDir ? <SortAlphaDown/>:<SortAlphaDownAlt/>;
			} else if (val.type == "daterange"){
				sortBtn = val.sortDir ? <SortDownAlt/>:<SortDown/>;

			}
			sortBtnMap[key] = <Button className="sort-button" onClick={sortAction(key)}> {sortBtn} </Button>;
		} else {
			sortBtnMap[key] = <Button className="sort-button" onClick={sortAction(key)}><ArrowDownUp></ArrowDownUp> </Button>;
		}
	}

	// Returns the input fields for the filtering options
	let getFilterInputs = function(){
		let result = [];

		// Used for string types
		let updateStringSearches = function(e, key, val){
			let x = {
				...search,
				[key]: {
					...val,
					value: e.target.value
				}
			}
			setSearch(x);
		}

		// Used for date types
		let updateDateRange = function(start, end, key, val){

			let x = {
				...search,
				[key]: {
					...val,
					start: start,
					end: end,
				}
			}
			setSearch(x);
		}

		for(const[key, val] of Object.entries(search)){
			if(val.type === "string_submatch"){
				result.push(<div className="search-query" key={key + "_search"}>
					<label>{val.label}</label>
					<input className="search-bar" value={val.value} onChange={(e) => {updateStringSearches(e, key, val) }} ></input>
					</div>);
			} else if (val.type === "daterange"){
				result.push(<div key={key + "_search"}>
					<label>{val.label}</label>
					<DateRangePicker
					onChange={({ detail }) => {detail.value? updateDateRange(detail?.value.startDate, detail?.value.endDate, key, val): updateDateRange("", "", key, val)}}
					value={{type: "absolute", startDate: val.start, endDate: val.end}}
					relativeOptions={[]}
					isValidRange={range => {
						if (range.type === "absolute") {
						const [
							startDateWithoutTime
						] = range.startDate.split("T");
						const [
							endDateWithoutTime
						] = range.endDate.split("T");
						if (
							!startDateWithoutTime ||
							!endDateWithoutTime
						) {
							return {
							valid: false,
							errorMessage:
								"The selected date range is incomplete. Select a start and end date for the date range."
							};
						}
						if (
							new Date(range.startDate) -
							new Date(range.endDate) >
							0
						) {
							return {
							valid: false,
							errorMessage:
								"The selected date range is invalid. The start date must be before the end date."
							};
						}
						}
						return { valid: true };
					}}
					i18nStrings={{applyButtonLabel: "Apply", cancelButtonLabel: "Cancel", clearButtonLabel: "Clear"}}
					dateOnly
					placeholder="Filter by date"
					rangeSelectorMode="absolute-only"
					/>
					</div>);
			}
		}
		return result;
	}


	let getAllJobs = () => {
		getDB().then(db => {
			db.getAll("Jobs").then(newJobs => {
				setJobs(newJobs);
				// setJobs(SampleJobs());
			});
		});
	};
	if (jobs == emptyArray) {
		getAllJobs();
	}

	let makeJobActiveAction = (job) => () => {
		let newProfile = new User();
		Object.assign(newProfile, profile); // Make sure we get a new object for state updates
		newProfile.job = job; // Update job
		setProfile(newProfile); // Set and Save
		User.saveUser(newProfile);
	};


	// Get the jobs based off of the user search
	const filteredJobs = jobs.filter(filterKey).sort(sortFunction);
	const pagedJobs = filteredJobs.filter((_, idx) => {return (paginationIndex * pageSize <= idx && idx < paginationIndex * pageSize + pageSize)})


	const getSortButtons = function(){

		let result = [];

		for(const [key, val] of Object.entries(search)) {
			result.push(<th key={key + "_sortBtn"}> {val.label} {sortBtnMap[key]} </th>)
		}
		return result;
	}

	return (
		<div className="jobListingPageContainer">
			<h1>
				{isVault ? "Inspection Jobs" : "Jobs"}
				<Link to="/jobs/new" className="float-end"><Button>New Job</Button></Link>
			</h1>
			<div className="clearfix"></div>
			<div>
				
				
				<Button onClick={() => setOpenSearch(!openSearch)}> {openSearch ? <FilterCircleFill></FilterCircleFill> : <FilterCircle></FilterCircle>} Filter </Button>
				
				<div className='search-menu'>
					{openSearch && getFilterInputs(search)}
				</div>
				<hr></hr>

			</div>

			{filteredJobs.length == 0 && <p>No active jobs are currently available.</p>}
			{filteredJobs.length > 0 && <div className="table-responsive">


				<table className="table">
					<thead>
						<tr>
							<th>Active</th>
							{getSortButtons()}
							<th></th>
						</tr>
					</thead>
					<tbody>
						{pagedJobs.map(job => <tr key={job.id}>
							<td>
								{profile.job?.id == job.id && <CheckLg />}
								{profile.job?.id != job.id && <Button variant="warning" size="sm" onClick={makeJobActiveAction(job)}>Make&nbsp;Active</Button>}
							</td>
							<td>{job.name} <SharingStatus ownerUid={job.userIdentifier} profile={profile} childAutoAccess={true} /></td>
							<td>{job.companyName}</td>
							<td>{job.location}</td>
							<td>{job.updatedAt}</td>
							<td>
								<Link to={`/jobs/${encodeURIComponent(job.id)}`}><Button variant="primary" size="sm">Show</Button></Link>&nbsp;
								{job.userIdentifier == profile.id && <Link to={`/jobs/${encodeURIComponent(job.id)}/edit`}><Button variant="primary" size="sm">Edit</Button></Link>}
								{job.userIdentifier != profile.id && <Lock />}
							</td>
						</tr>)}
						<tr>
							<td>
								{profile.job == null && <span>No&nbsp;Active&nbsp;Job</span>}
								{profile.job != null && <Button variant="warning" size="sm" onClick={makeJobActiveAction(null)}>No&nbsp;Active&nbsp;Job</Button>}
							</td>
							<td colSpan="4"></td>
						</tr>
					</tbody>
				</table>
			</div>}
			<hr />
			<PaginationSelector numItems={filteredJobs.length} index={paginationIndex} setIndex={setPaginationIndex} pageSize={pageSize}></PaginationSelector>
			<hr />
		</div>
	)
}